import styled from 'styled-components'

import { Heading4 } from '~/components/common/typography'

export const BoxTitle = styled(Heading4)`
  color: ${({ theme }) => theme._neo.textColor02};
  display: block;
  margin: 0 0 8px 0;
`

export const Card = styled.div`
  background-color: ${({ theme }) => theme._neo.ui06};
  border: 1px solid ${({ theme }) => theme._neo.ui01};
  border-radius: 6px;
  box-shadow: 0px 2px 6px rgba(41, 41, 41, 0.15);
  box-sizing: border-box;
  margin: 0 24px 24px;
  overflow: hidden;
  width: calc(100% - 48px);

  &:first-child {
    margin-top: 24px;
  }
`

export const LoaderCard = styled(Card)`
  box-sizing: border-box;
  padding: 16px;
`
